import { defineComponent as _defineComponent } from 'vue'
import InputAvatar from '@/features/ui/components/InputAvatar.vue';
import InputSelect from '@/features/ui/components/InputSelect.vue';
import InputText from '@/features/ui/components/InputText.vue';
import InputTextArea from '@/features/ui/components/InputTextArea.vue';
import ProfileView from '@/features/user-profile/components/ProfileView.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import Spinner from '@/ui-components/Spinner.vue';

import { useUserProfile } from '@/features/user-profile/composables/useUserProfile';
import { useUserProfileEdit } from '@/features/user-profile/composables/useUserProfileEdit';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { computed, ref } from 'vue';
import { toastSuccess, toastError } from '@/helpers/vfm/toast-helper';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileEdit',
  setup(__props) {

const { profile } = useUserProfile();
const { profileData, submitProfile, countries, onError, onDone, loading } = useUserProfileEdit();
const { country } = useLanguageStore();

const { tc } = useI18n();

const prefilledCountry = ref(countries.find(c => c.value === country.value) || { item: '', value: '' });
const isSubmitting = ref(false);

const prefilledCountryValue = computed({
	get: () => prefilledCountry.value.value,
	set: newValue => {
		const country = countries.find(c => c.value === newValue);
		if (country) prefilledCountry.value = country;
	},
});

const isButtonDisabled = computed(() => {
	return isSubmitting.value || loading.value;
});

function handleAvatarBase64(base64: string) {
	profileData.avatarBase64 = base64;
}

function handleSubmit() {
	isSubmitting.value = true;
	submitProfile();
}

onError(() => {
	isSubmitting.value = false;
	toastError({ message: tc('WEBAPP_PROFILE_UPDATED_ERROR') });
});

onDone(() => {
	isSubmitting.value = false;
	toastSuccess({ message: tc('WEBAPP_PROFILE_UPDATED_SUCCESS') });
});

return { __sfc: true,profile, profileData, submitProfile, countries, onError, onDone, loading, country, tc, prefilledCountry, isSubmitting, prefilledCountryValue, isButtonDisabled, handleAvatarBase64, handleSubmit, InputAvatar, InputSelect, InputText, InputTextArea, ProfileView, BasicButton, Spinner }
}

})